var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 17.7C8.4 17.3 8.4 16.7 8.8 16.3L13.1 12L8.8 7.7C8.4 7.3 8.4 6.7 8.8 6.3C9.2 5.9 9.8 5.9 10.2 6.3L15.2 11.3C15.4 11.5 15.5 11.8 15.5 12C15.5 12.3 15.4 12.5 15.2 12.7L10.2 17.7C9.8 18.1 9.2 18.1 8.8 17.7Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.8f7375b2126ba06a6624422642287a40.svg";
export { ForwardRef as ReactComponent };